<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name : "添加管理员" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form label-width="100px" v-model="form">
                <el-form-item label="用户名：" :rules="[{ required: true }]">
                    <el-input type="text" v-model="form.userName" style="width:20em"></el-input>
                </el-form-item>
                <el-form-item label="密码：" :rules="[{ required: true }]">
                    <el-input type="password" v-model="form.password" style="width:20em"></el-input>
                </el-form-item>
                <el-form-item label="权限：" :rules="[{ required: true }]">
                    <el-radio v-model="form.radio" label="0">超级管理员</el-radio>
                    <el-radio v-model="form.radio" label="1">管理员</el-radio>
                </el-form-item>
                <el-form-item label="状态：" :rules="[{ required: true }]">
                    <el-radio v-model="form.status" label="0">正常</el-radio>
                    <el-radio v-model="form.status" label="1">待审核</el-radio>
                    <el-radio v-model="form.status" label="2">驳回</el-radio>
                    <el-radio v-model="form.status" label="3">冻结</el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            form: {
                userName: null,
                password: null,
                radio: null,
                status: null,
            },
        };
    },
    computed: {
        ...mapState(["theme"]),
    },
    methods: {
        /*确定添加*/
        determine() {
            if (!this.form.userName || !this.form.password) {
                this.$notify.warning({
                    title: "警告",
                    message: "必填项不能为空",
                });
                return;
            }
            let postData = {
                userName: this.form.userName,
                password: this.form.password,
            };
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>

<style></style>
